import { render, staticRenderFns } from "./end2.vue?vue&type=template&id=3baa3cb5&scoped=true"
import script from "./end2.vue?vue&type=script&lang=js"
export * from "./end2.vue?vue&type=script&lang=js"
import style0 from "./end2.vue?vue&type=style&index=0&id=3baa3cb5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baa3cb5",
  null
  
)

export default component.exports